<div mat-dialog-title>{{ title }}</div>
<div mat-dialog-content>
  @if (values) {
    <mat-form-field appearance="outline" style="width: 100%;">
      <mat-icon matIconPrefix>search</mat-icon>
      <mat-label class="as-search-label" for="value-search">Search</mat-label>
      <input matInput #searchBox class="searchBox" type="text" id="value-search" (keyup)="onSearchChanged(searchBox.value)"/>
    </mat-form-field>
    <a class="selection" href="javascript:;"
    (click)="selectAll(values)">{{ 'SelectAllString' | translate:locale.language }}</a>
    <a class="selection" href="javascript:;" (click)="clearPage(values)">{{ 'Clear' | translate:locale.language}}</a>
    <div class="section no-pad-top checkbox-container">
      @for (item of values; track item) {
        <p
          >
          <mat-checkbox class="associationValue" [checked]="isSelectedCheck(item.value)" aria-label="name"
          (change)="manageValues(item.value)">{{ item.name }}</mat-checkbox>
        </p>
      }
    </div>
  } @else {
    @if (!values) {
      <div>
        <app-loading [hasLoaded]="!!values" [hasFailed]="loadFailed" (retryClicked)="updateValues()"></app-loading>
      </div>
    }
  }

</div>

@if (values) {
  <div mat-dialog-actions class="button-row right">
    <div id="select-pagination">
      @if (count > pageSize) {
        <mat-paginator id="id"
          [length]="count" [pageSize]="pageSize" [pageIndex]="page - 1" [hidePageSize]=true
          (page)="onPageChanged($event.pageIndex + 1)">
        </mat-paginator>
      }
    </div>
    @if (showButton) {
      <button mat-raised-button color="primary" id="qa-confirm-send-button" (click)="apply()" [mat-dialog-close]="true">{{ 'OK' | translate:locale.language }}</button>
    }
  </div >
}